import { Application, Assumptions, LeadOrigin } from "@justhome/api-core";
import { ApplicationFormValues } from "./types";
import {
  getCosts,
  getLoanAmount,
  getPreferences,
  getProperty,
  getSpecialApplicationData,
} from "./utilities";

/**
 * Mapping data before create application
 */
const mapApplicationData = (
  data: ApplicationFormValues,
  assumptions: Assumptions,
  utmOrigin?: LeadOrigin,
) => {
  const costs = getCosts(data, assumptions);
  const loanAmount = getLoanAmount(data, costs);
  const preferences = getPreferences();
  const specialApplicationData = getSpecialApplicationData(data);
  const property = getProperty(data);
  const application: Application = {
    loanAmount,
    applicationType: data.applicationType,
    preferences,
    costs,
    property,
    ...specialApplicationData,
  };

  if (utmOrigin) {
    application.origin = utmOrigin;
  }

  return application;
};

export default mapApplicationData;
